import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";

export const ReKycContext = createContext();

const initFormData = {
  customerID: "",
  changeInKYC: "false",
  otp: "",
  customerName: "",
  annualIncome: "",
  haveAcceptedTermsAndCondition: false,
  isCommunicationAddressSameAsPermanentAddress: "true",
  occupation: "",
  aadharNumber: "",
  aadharValidationOtp: "",
  idProofDocument: "aadhar",
  addressProofDocument: "",
  idProof: "",
  addressProof: "",
  permanentAddress: {
    addressLine_1: "",
    addressLine_2: "",
    addressLine_3: "",
    country: "",
    state: "",
    city: "",
    pincode: "",
  },
  //   communicationAddress: {
  //     addressLine_1: "",
  //     addressLine_2: "",
  //     addressLine_3: "",
  //     country: "",
  //     state: "",
  //     city: "",
  //     pincode: "",
  //   },
};

const initCommunationAddressdata = {
  addressLine_1: "",
  addressLine_2: "",
  addressLine_3: "",
  country: "",
  state: "",
  city: "",
  pincode: "",
};

export const ReKycProvider = ({ children }) => {
  const [form, setForm] = useState(initFormData);
  const [communicationAddress, setCommunicationAddress] = React.useState(
    initCommunationAddressdata
  );

  return (
    <ReKycContext.Provider
      value={{ form, setForm, communicationAddress, setCommunicationAddress }}
    >
      {children}
    </ReKycContext.Provider>
  );
};

ReKycProvider.propTypes = {
  children: PropTypes.node,
};

export const useReKyc = () => {
  const context = useContext(ReKycContext);
  if (!context) {
    throw new Error("useReKyc must be used within a ReKycProvider");
  }
  return context;
};
